import React, { useEffect, useRef, useState } from "react"
import { defPath, fetchPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { useSession } from "../hooks/useState";
import { LotteryFormPage } from "../components/lottery/LotteryFormPage";
import { LotteryState } from "../config/types";
import { LotterySuccess } from "../components/lottery/LotteryConfirm";
import { LotteryStatus } from "../components/lottery/LotteryStatus";
// import { useSession } from '../hooks/useState'

function Lottery() {
  const [code, setCode] = useState([]);
  const [page, setPage] = useState('loading'); // loading | lottery | confirm | not-active
  const [lotteryData, setLotteryData] = useState<LotteryState>(null);

  useEffect(() => {

    fetch(`${fetchPath}/aguila/loyalty/get-lottery`)
      .then(res => res.json() as Promise<LotteryState>)
      .then(data => {

        setLotteryData(data)

        const { status, prediction, lottery } = data
        
        if (lottery?.active === 1) {
          setPage("not-active")
          return
        }

        if (status === 0) {
          setCode(prediction.split(","))
          setPage("confirm")
          return
        }
        
        if (status === 1) {
          setPage("lottery")
          return
        }

      })
  }, [])


  return (
    <>

      {/* Background Image */}
      {page === "confirm" ? (
        <picture className="">
          <source className="" media="(min-width: 1024px)" srcSet={`${defPath}/assets/images/internNotice/bkLimit.jpeg`} />
          <img loading={"lazy"} className="lotteryConfirm--bk" src={`${defPath}/assets/images/lottery/bg_lottery_success_mob.jpg`} alt="" />
        </picture>

      ) : (
        <picture className="lottery--pictures">
          <source className="" media="(min-width: 1024px)" srcSet={`${defPath}/assets/images/lottery/bg_lottery_desk.jpg`} />
          <img loading={"lazy"} className="lottery--bk" src={`${defPath}/assets/images/lottery/bg_lottery_mob.jpg`} alt="fondo azul" />
        </picture>
      )}


      <div className="lottery">
        <header className="lottery__header">
          <NewHeader />
          <Modal />
        </header>
        <section className="lottery__container scrollBar">
          {
            page === "lottery" && <LotteryFormPage data={lotteryData.lottery} setPage={setPage} setCode={setCode} />
          }
          {
            page === "confirm" && <LotterySuccess data={lotteryData.confirm} code={code} />
          }
          {
            page === "not-active" && <LotteryStatus data={lotteryData.lottery}  />
          }
        </section>
      </div>
    </>
  )
}

export default Lottery